<template>
  <div class="d-flex flex-column flex-grow-1">
    <NummernSucheSelect
      @input="selectedIds = $event"
      :optionsArray="optionsArray"
      :value="selectedIds"
      :storeFunction="storeFunction"
      :placeholder="placeholder"
      :objectName="objectName"
    ></NummernSucheSelect>
    <div class="mt-4">
      <b-form-radio
        v-for="option in stateOptions"
        :key="option.value"
        :value="option.value"
        v-model="selectedState"
        class="mb-3"
      >
        {{ option.text }}
      </b-form-radio>
    </div>
    <div class="d-flex mt-4 flex-grow-1">
      <b-button
        :disabled="!hasSelection"
        variant="outline-secondary"
        @click="onReset"
        class="flex-grow-1 mr-2"
      >
        Zurücksetzen
      </b-button>
      <b-button :disabled="!hasChanges" @click="onApply" variant="primary" class="flex-grow-1">
        Anwenden
      </b-button>
    </div>
  </div>
</template>

<script>
import NummernSucheSelect from '@/components/common/nummern-suche-select.vue';

// Gemeinsamer Dubletten-Filter aus Id-Suche und Status-Auswahl
// Der angewendete Stand kommt über appliedIds/appliedState herein, das Anwenden geht als Event heraus
export default {
  components: {
    NummernSucheSelect,
  },
  props: {
    optionsArray: { type: Array, default: () => [] },
    storeFunction: { type: Function },
    placeholder: { type: String },
    objectName: { type: String },
    stateOptions: { type: Array, default: () => [] },
    appliedIds: { type: Array, default: () => [] },
    appliedState: { type: String, default: null },
  },
  data() {
    return {
      selectedState: null,
      selectedIds: [],
    };
  },
  computed: {
    hasSelection() {
      return this.selectedState !== null || this.selectedIds.length > 0;
    },
    hasChanges() {
      return (
        this.selectedState !== (this.appliedState || null) ||
        JSON.stringify(this.selectedIds) !== JSON.stringify(this.appliedIds || [])
      );
    },
  },
  watch: {
    appliedIds: {
      immediate: true,
      handler(val) {
        this.selectedIds = val ? [...val] : [];
      },
    },
    appliedState: {
      immediate: true,
      handler(val) {
        this.selectedState = val || null;
      },
    },
  },
  methods: {
    onApply() {
      this.$emit('apply', { ids: this.selectedIds, state: this.selectedState });
    },
    onReset() {
      this.selectedState = null;
      this.selectedIds = [];
    },
  },
};
</script>

<style scoped>
button:disabled {
  cursor: default;
}
</style>
